import { render, staticRenderFns } from "./CustomersUsed.vue?vue&type=template&id=18b2b6e8&scoped=true"
import script from "./CustomersUsed.vue?vue&type=script&lang=js"
export * from "./CustomersUsed.vue?vue&type=script&lang=js"
import style0 from "./CustomersUsed.vue?vue&type=style&index=0&id=18b2b6e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2b6e8",
  null
  
)

export default component.exports